module.exports = __webpack_public_path__ + "img/image2.4572a62b.png";